import { Client, Hub, KeyValue } from "common/models";
import apiClient from "./apiClient";

const getAllClients = async (excludeBarge = false): Promise<Client[]> => {
  return apiClient.get(`/lookup/clients?excludeBarge=${excludeBarge}`);
};

const getAllHubs = async (): Promise<Hub[]> => {
  return apiClient.get("/hubs");
};
const getHubsByClient = async (clientId): Promise<Hub[]> => {
  return apiClient.get(`/hubs/client/${clientId}`);
};
const getOrderStatuses = async (): Promise<KeyValue[]> => {
  return apiClient.get("/lookup/order-statuses");
};
const getDrivers = async (hubId, activeOnly = false): Promise<any> =>{
  return apiClient.get(`/lookup/drivers/${hubId}${activeOnly ? "?activeOnly=true" : ""}`);
}
const getDriverTypes = async (): Promise<KeyValue[]> => {
  return apiClient.get(`/lookUp/drivers/types`);
};
const getDriverStatuses = async (): Promise<KeyValue[]> => {
  return apiClient.get(`/lookUp/drivers/statuses`);
};

const getVehicleTypes = async (): Promise<KeyValue[]> => {
  return apiClient.get("/lookup/vehicles/types");
};

const getVehicleStatuses = async (): Promise<KeyValue[]> => {
  return apiClient.get("/lookup/vehicles/statuses");
};

const getOutOfServiceReasons = async (): Promise<KeyValue[]> => {
  return apiClient.get("/lookup/vehicles/out-of-service-reasons");
};

const getDispatchProcesses = async (): Promise<KeyValue[]> =>{
  return apiClient.get("/lookup/hubs/dispatch-processes");
}
const getShiftDataSources = async (): Promise<KeyValue[]> =>{
  return apiClient.get("/lookup/hubs/data-sources");
}
const getTripTypes = async (): Promise<KeyValue[]> =>{
  return apiClient.get("/lookup/trips/types");
}
const getPointOfService = async (clientId: number, hubId: number): Promise<KeyValue[]> =>{
  return apiClient.get(`/lookUp/points-of-service?clientId=${clientId}&hubId=${hubId}`);
}
const getSubcontractors = async (hubId: number): Promise<KeyValue[]> =>{
  return apiClient.get(`/lookup/subcontractors/${hubId}`);
}

const getTripCancelReasons = async (): Promise<KeyValue[]> =>{
  return apiClient.get(`/lookup/trip-cancel-reasons`);
}

const getTripDeclineReasons = async (): Promise<KeyValue[]> =>{
  return apiClient.get(`/lookup/trip-refuse-reasons`);
}

const getLocationServiceTypes = async (): Promise<KeyValue[]> =>{
  return apiClient.get(`/lookup/location-service-types`);
}

const getWaitReasons = async (clientId:number): Promise<KeyValue[]> =>{
  return apiClient.get(`/lookup/wait-reasons/${clientId}`);
}

const getEventTypes = async (): Promise<KeyValue[]> =>{
  return apiClient.get(`/lookup/event-types`);
}

const getShiftTypes = async (): Promise<KeyValue[]> =>{
  return apiClient.get(`/lookup/shift-types`);
}

const orgDataService = {
  getAllClients,
  getAllHubs,
  getHubsByClient,
  getOrderStatuses,
  getDrivers,
  getDriverTypes,
  getDriverStatuses,
  getVehicleTypes,
  getVehicleStatuses,
  getOutOfServiceReasons,
  getDispatchProcesses,
  getShiftDataSources,
  getTripTypes,
  getPointOfService,
  getSubcontractors,
  getTripCancelReasons,
  getTripDeclineReasons,
  getLocationServiceTypes,
  getWaitReasons,
  getEventTypes,
  getShiftTypes
};

export default orgDataService;
